import type { Nullable } from 'corgi-types';

import type { RecentSearch } from '../../../utils/recent-searches';
import type { Suggestion } from '../gql/types';
import type { SuggestionItem } from '../types';

export const getSuggestionName = (suggestion: Nullable<{ name: string }>) => suggestion?.name ?? '';

export const getInputLength = (value: string) => value.trim().length;

export const createHighlightedText = (text: string, match: string) => {
  // Trim the string and escape special regex chars
  match = match.trim().replace(/[\\^$.*+?()[\]{}|]/g, '\\$&');

  const regex = new RegExp(`(${match})`, 'ig');

  return match ? text.replace(regex, '<strong>$1</strong>') : text;
};

export const attachEncodedUrl = (suggestion: Suggestion, urlParams?: string): SuggestionItem => ({
  ...suggestion,
  urlEncoded: `/search?${new URLSearchParams({ query: suggestion.name })}${urlParams ? `&${urlParams}` : ''}`,
});

export const mapRecentSearchToSuggestionItem = ({ keyword, thumbnail }: RecentSearch) =>
  attachEncodedUrl({
    name: keyword,
    image: thumbnail,
    count: 0,
  });

export const formatCountDisplay = (count?: number | null) => {
  const SUGGESTION_RESULT_LIMIT = 10000;

  if (!count) {
    return 0;
  }

  if (count >= SUGGESTION_RESULT_LIMIT) {
    return `${SUGGESTION_RESULT_LIMIT}+`;
  }

  return count;
};
